export enum AppPage {
  Dashboard           = 'Dashboard',
  NotificationsCenter = 'Notifications Center',
  CCMReviews          = 'CCM Reviews',
  BHIReviews          = 'BHI Reviews',
  RPMReviews          = 'RPM Reviews',
  Reports             = 'Reports',
  ActiveDeviceUtilizationReport = 'Active Device Utilization',
  QualityAudits       = 'Quality Audits',
  Administration      = 'Administration',
  UserManagement      = 'User Management',
  Announcements       = 'Announcements'
}
